import { map } from 'lodash';

export default function formatOptions(opts) {
  return map(opts, (opt) => ({ label: opt.display_name, value: opt.value }));
}
